const dialog = document.getElementById('product-dialog');
const dialogImage = document.getElementById('dialog-image');
const firstView = document.getElementById('gallery-primary');
const secondView = document.getElementById('gallery-secondary');
const gallery = document.getElementById('dialog-gallery');
let activeCard;

function showImage(useSecond) {
  if (!activeCard) return;
  const src = useSecond ? activeCard.dataset.secondaryImage : activeCard.dataset.image;
  dialogImage.src = src;
  dialogImage.alt = `${activeCard.dataset.name} ${useSecond ? activeCard.dataset.secondaryLabel : activeCard.dataset.primaryLabel || 'product'} image`;
  firstView.setAttribute('aria-pressed', String(!useSecond));
  secondView.setAttribute('aria-pressed', String(useSecond));
}

document.querySelectorAll('.product-card').forEach((card) => {
  card.addEventListener('click', () => {
    activeCard = card;
    const hasSecond = Boolean(card.dataset.secondaryImage);
    document.getElementById('dialog-title').textContent = card.dataset.name;
    document.getElementById('dialog-range').textContent = `SCENTMART / ${card.dataset.range}`;
    document.getElementById('dialog-size').textContent = card.dataset.size;
    document.getElementById('dialog-price').textContent = card.dataset.price || '';
    document.getElementById('dialog-notes').textContent = card.dataset.notes;
    const reference = document.getElementById('dialog-reference');
    reference.textContent = card.dataset.reference || '';
    reference.hidden = !card.dataset.reference;
    firstView.querySelector('img').src = card.dataset.image;
    firstView.querySelector('span').textContent = card.dataset.primaryLabel || 'Product image';
    if (hasSecond) {
      secondView.querySelector('img').src = card.dataset.secondaryImage;
      secondView.querySelector('span').textContent = card.dataset.secondaryLabel || 'Second view';
    }
    gallery.classList.toggle('single', !hasSecond);
    secondView.hidden = !hasSecond;
    const message = `Hello Scentmart India, I would like to know more about ${card.dataset.name} (${card.dataset.size}).`;
    document.getElementById('dialog-whatsapp').href = `https://wa.me/917069635981?text=${encodeURIComponent(message)}`;
    showImage(false);
    dialog.showModal();
  });
});

firstView.addEventListener('click', () => showImage(false));
secondView.addEventListener('click', () => showImage(true));
document.getElementById('close-dialog').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
